import { win } from '@rei/browser-shim';

export default ({ radius: radConfig }) =>
  () =>
  ({ locationFilter, distanceFilter }) => {
    const radius = parseInt(distanceFilter, 10) || radConfig;
    return {
      props: {
        showChallenger: true,
        location: locationFilter,
        radius,
        class: 'mobile-only',
        mobile: false,
        page: 'course',
      },
      on: {
        updateLocation(/* nextLocation, radius */) {
          // this is here as documentation only
          // add/update operations are exclusively handled by
          // @rei/location-search, LocationSearchFacet, and course-location-search
        },
        removeLocation() {
          if (win.appObservable) {
            win.appObservable.getSearchResults({ searchString: null });
          }
        },
      },
    };
  };
